import { Fragment, ReactNode, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { DialogProps } from '@/types/interfaces';
import { Spinner } from '@/shared/spinner/spinner';
import { CrossBlackIcon } from "@/components/assets/icons/svgs";
import CustomButton from '@/shared/button/customButton';
import { useTranslation } from 'react-i18next';

function VerifySubmission({
  headerTitle,
  size,
  isOpen,
  handleSubmit,
  handleClose,
  children,
  isLoading,
  cancelButtonLabel,
  confirmButtonLabel,
}: DialogProps) {
  const { t } = useTranslation();
  const clickHandleSubmit = () => {
    handleSubmit();
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth={size || 'md'}
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: 3,
            backgroundColor: 'background.paper',
          },
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 700, textTransform: 'none', color: '#000', fontFamily: 'Object Sans, sans-serif', fontSize: '20px' }}>{headerTitle}</span>

        <IconButton onClick={handleClose} size="small">
          <CrossBlackIcon />

        </IconButton>

      </DialogTitle>

      <DialogContent sx={{ padding: '24px' }}>
        {children}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: '16px 24px' }}>
        <CustomButton
          className={`!rounded-lg w-full ${cancelButtonLabel ? 'bg-white border border-[#CCCCCC]' : '!bg-darkBlue'}`}
          style={cancelButtonLabel ? { padding: '12px 14px', borderRadius: '8px' } : { borderRadius: '8px' }}
          labelStyle={`${cancelButtonLabel ? 'text-[#444444]' : 'text-white'}`}
          handleButtonClick={handleClose}
          label={cancelButtonLabel || t('no')}
        />

        <CustomButton
          isLoading={isLoading}
          className={`!rounded-lg w-full ${confirmButtonLabel ? 'bg-[#4285F4]' : 'border bg-opacity-10 border-darkBlue border-opacity-40 bg-blue-100'}`}
          style={confirmButtonLabel ? { padding: '12px 14px', borderRadius: '8px' } : { borderRadius: '8px' }}
          labelStyle={`${confirmButtonLabel ? 'text-white' : 'text-darkBlue'}`}
          handleButtonClick={clickHandleSubmit}
          label={confirmButtonLabel || t('yes')}
        />


      </DialogActions>
    </Dialog>
  );
}

export default VerifySubmission;
